import { useAuthorizedPersonStore } from './authorizedPerson.js'
import { useClientStore } from './client.js'
import { useModalStore } from './modal.js'
import { useUnitTypeStore } from './unitType.js'
import { useContractStore } from './contract.js'
import { useContractFilesStore } from './contractFiles.js'
import { useClientFilesStore } from './clientFiles.js'
import { useTokenStore } from './token.js'
import { useInvoicesStore } from './invoices.js'
import { useUsersStore } from './users.js'

export const storeRegistry = {
    authorizedPerson: useAuthorizedPersonStore,
    client: useClientStore,
    modal: useModalStore,
    unitType: useUnitTypeStore,
    contract: useContractStore,
    contractFiles: useContractFilesStore,
    clientFiles: useClientFilesStore,
    token: useTokenStore,
    invoices: useInvoicesStore,
    users: useUsersStore,
}
